let vmax = {
    update($el, binding) {
        var val = parseInt($el.value);
        if (binding.value === null) {
            return;
        }
        var max = parseInt(binding.value);
        if (val > max) {
            $el.value = max;
            $el.dispatchEvent(new Event('input'));
        }
    }
};
let vmin = {
    update($el, binding) {
        var val = parseInt($el.value);
        if (binding.value === null) {
            return
        }
        var min = parseInt(binding.value);
        if (val < min) {
            $el.value = min;
            $el.dispatchEvent(new Event('input'));
        }
    }
};
let vdefault = {
    update($el, binding) {
        var def = parseInt(binding.value || 1);
        
        if ($el.value == '' || $el.value == null){
            $el.value = def;
            $el.dispatchEvent(new Event('input'));
        }
    }
};
export {vmax, vmin, vdefault};


// WEBPACK FOOTER //
// ./resources/assets/js/loja/vue-directives.js